import { Button, InfoInput, Typography } from '@p2p/components';
import { useGetMerchantOrderQuery } from '@p2p/services';
import { PaymentType } from '@p2p/shared/constants';
import { formatCardNumber, formatCurrencyAmount, formatPhoneNumber } from '@p2p/shared/functions';
import { useParams } from 'react-router-dom';

import { PaymentTimer } from '../PaymentTimer/PaymentTimer';
import styles from './InfoBlock.module.scss';
import { InfoBlockProps } from './InfoBlock.types';

const RequisitesBlock = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { data: order } = useGetMerchantOrderQuery(id, { skip: !id });

  if (!order) {
    return null;
  }

  const isSBP = order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP;
  const isC2C = order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_C2C;
  // P2P-2880: на proof_page (реквизиты трейдеров PayGo) бывает и перевод по номеру счёта;
  // на msp_page такого типа нет.
  const isTransfer = order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_TRANSFER;

  return (
    <>
      <div className={styles.infoInputsContainer}>
        {isSBP && (
          <InfoInput
            label="Номер телефона"
            value={formatPhoneNumber(order?.requisite.phone_number)}
            canCopy
            className={styles.infoInput}
          />
        )}
        {isC2C && (
          <InfoInput
            label="Номер карты"
            value={formatCardNumber(order?.requisite.account_number || '')}
            canCopy
            className={styles.infoInput}
          />
        )}
        {isTransfer && (
          <InfoInput
            label="Номер счета"
            value={order?.requisite.account_number || ''}
            canCopy
            className={styles.infoInput}
          />
        )}
        <InfoInput
          label="Наименование банка"
          value={order?.requisite.bank.name || ''}
          canCopy
          className={styles.infoInput}
        />
      </div>
      <InfoInput
        label="Сумма транзакции, RUB"
        value={formatCurrencyAmount(order?.expected_income || 0)}
        canCopy
        className={styles.marginBottomMedium}
      />
    </>
  );
};

export const InfoBlock = ({ isShortView, handleShortView }: InfoBlockProps) => {
  const { id = '' } = useParams<{ id: string }>();
  const { data: order } = useGetMerchantOrderQuery(id, { skip: !id });
  const isSBP = order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP;

  if (isShortView) {
    return (
      <>
        <Typography variant="h3" color="heading" className={styles.marginBottomSmall}>
          Реквизиты операции
        </Typography>
        <RequisitesBlock />
      </>
    );
  }

  return (
    <>
      <Typography variant="h3" color="heading" className={styles.marginBottomSmall}>
        Отправьте указанную сумму
      </Typography>
      <Typography variant="text-m-medium" className={styles.marginBottomSmall}>
        Переведите точную сумму на указанные реквизиты в течении данного времени
      </Typography>
      {isSBP && (
        <Typography variant="text-m-medium" className={styles.marginBottomMedium}>
          Если переведете в другой банк - средства могут быть утеряны.
        </Typography>
      )}

      <PaymentTimer time={order?.time_left || 0} className={styles.marginBottomMedium} />
      <RequisitesBlock />

      <Button variant="default" className={styles.button} onClick={handleShortView}>
        Деньги отправлены
      </Button>
    </>
  );
};
